module.exports = __webpack_public_path__ + "2b07ff59215d21d1f552232bdfde5078.MP3";